import api from "@/frontend/api";

export default {
    getAccess: () => api.get('users/get-access'),
    signIn: params => api.post('users/sign-in', params),
    signUp: params => api.post('users/sign-up', params),
    verifyEmail: params => api.post('users/verify-email', params),
    requestPasswordReset: params => api.post('users/request-password-reset', params),
    validateToken: token => api.post('users/validate-token/' + token),
    resetPassword: (params, token) => api.post('users/reset-password/' + token, params),
    resend: params => api.post('users/resend', params),
    logout: () => api.post('users/logout'),
    update: (id, params) => api.post('users/' + id, params),
    get: (params, id = null) => api.get('users' + (id ? '/' + id : ''), params),
}